import { WandSparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ImproveStatus } from './useImproveText';
import { KBD, TOOL_BUTTON, isApplePlatform } from './toolStyles';

type Props = {
  status: ImproveStatus;
  disabled: boolean;
  onImprove: () => void;
  onCancel: () => void;
};

/**
 * „Verbessern ⌘J“; while streaming the SAME button turns into „Abbrechen
 * (Esc)“ next to a quiet progress label. One element throughout, so the
 * keyboard focus stays on it (and Esc keeps working) when the state flips.
 */
export function ImproveControls({ status, disabled, onImprove, onCancel }: Props) {
  const streaming = status === 'streaming';
  const shortcut = isApplePlatform() ? '⌘J' : 'Strg+J';

  return (
    <div className="ml-auto flex min-w-0 items-center gap-1">
      {streaming && (
        <span className="inline-flex min-w-0 items-center gap-1.5 px-1 text-[13px] font-medium text-brand">
          <WandSparkles className="h-4 w-4 flex-shrink-0 motion-safe:animate-pulse" aria-hidden="true" />
          <span className="truncate">wird verbessert …</span>
        </span>
      )}
      <button
        type="button"
        onClick={streaming ? onCancel : onImprove}
        disabled={!streaming && disabled}
        aria-label={streaming ? 'Verbessern abbrechen' : 'Verbessern'}
        aria-keyshortcuts={streaming ? 'Escape' : 'Meta+J Control+J'}
        title={streaming ? 'Abbrechen (Esc)' : `Als WhatsApp-Nachricht formulieren (${shortcut}) – Fakten bleiben unverändert`}
        className={cn(TOOL_BUTTON, !streaming && 'hover:text-brand')}
      >
        {streaming ? (
          <>
            Abbrechen
            <kbd className={KBD}>Esc</kbd>
          </>
        ) : (
          <>
            <WandSparkles className="h-4 w-4" aria-hidden="true" />
            <span>Verbessern</span>
            <kbd className={KBD}>{shortcut}</kbd>
          </>
        )}
      </button>
    </div>
  );
}

export default ImproveControls;
